import { render } from "./requiredsubs.vue?vue&type=template&id=19ee0ed4&scoped=true"
import script from "./requiredsubs.vue?vue&type=script&lang=js"
export * from "./requiredsubs.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=19ee0ed4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ee0ed4"]])

export default __exports__